// @flow

import appendQuery from 'append-query';
import { type Dispatch } from 'redux';
import flattenError from '../../helpers/flattenError';
import { isMultiLanguage, fetchData } from '../../helpers';
import { getActiveLanguage } from '../activeLanguage/selectors';

import type {
  StorePdbData,
  SetActivePdbItem,
  FetchingPdbData,
  FetchPdbDataSuccess,
  FetchPdbDataFailed,
  FetchResponse,
} from './types';

import type {
  RawFullPdbData,
} from '../../types/pdb';

import type { Dict } from '../../types/dict';
import type { Arguments, FetchError } from '../../helpers/fetchData';

import {
  STORE_PDB_DATA,
  SET_ACTIVE_PDB_ITEM,
  GET_PDB_DATA,
  GET_PDB_DATA_SUCCESS,
  GET_PDB_DATA_FAILED,
} from './constants';


export const storePdbData = (pdbData: Dict<RawFullPdbData>): StorePdbData => ({
  type: STORE_PDB_DATA,
  payload: pdbData,
});

export const setActivePdbItem = (id: string): SetActivePdbItem => ({
  type: SET_ACTIVE_PDB_ITEM,
  id,
});

export const receivePdbData = (pdbData: Dict<RawFullPdbData>) => (dispatch: Dispatch<*>) => {
  // store the pdb data itself
  dispatch(storePdbData(pdbData));
};


export const fetchingPdbData = (pdbId: number): FetchingPdbData => ({
  type: GET_PDB_DATA,
  pdbId,
});

export const fetchPdbDataSuccess = (pdbId: number, data: FetchResponse): FetchPdbDataSuccess => ({
  type: GET_PDB_DATA_SUCCESS,
  pdbId,
  payload: data,
});

export const fetchPdbDataFailed = (pdbId: number, err: Error | FetchError): FetchPdbDataFailed => ({
  type: GET_PDB_DATA_FAILED,
  pdbId,
  payload: flattenError(err),
});

type Fetcher = (_: Arguments) => Promise<{ json: FetchResponse }>;
export default (fn: Fetcher = fetchData) => (pdbId: number) => (
  async (dispatch: Dispatch<*>, getState: Function) => {
    const state = getState();
    const language = isMultiLanguage() ? getActiveLanguage(state) : null;
    const endpoint = appendQuery('/api/pdb', { pdbId });

    dispatch(fetchingPdbData(pdbId));

    let response;
    try {
      const { json } = await fn({ language, endpoint });
      response = json;
    } catch (err) {
      dispatch(fetchPdbDataFailed(pdbId, err));
      throw err;
    }

    dispatch(fetchPdbDataSuccess(pdbId, response));
  }
);
